import ServiceHeader from "../../ServiceComponents/ServiceHeader";
import ServiceBody from "../../ServiceComponents/ServiceBody";

import { FaGreaterThan } from "react-icons/fa6";

import ServiceSection from "../../PageElements/HomePageElements/ServiceSection";
import ConsultSection from "../../PageElements/HomePageElements/ConsultSection";

export default function UrologyPage() {
    return (
        <>
            <ServiceHeader
                childClass="urologyBGSection"
                breadcrumb={<>Services <FaGreaterThan size={15} /> Urology</>}
                title="Urology"
            />

            <ServiceBody
                serviceName="Urology"
            />
            <ServiceSection />
            <ConsultSection />
        </>
    )
}